// AboutMe.jsx
import React from "react";
import bgImage from "../assets/bg.jpg";
import puspak from "../assets/puspak.png";

const AboutMe = () => {
  return (
    <section
      style={{
        background: `linear-gradient(rgba(255,255,255,0.95), rgba(255,255,255,0.95)), url(${bgImage}) no-repeat center center`,
        backgroundSize: "cover",
      }}
      className="py-5"
    >
      <div className="container">
        <div className="row align-items-center mb-5">
          <div className="col-md-4 text-center mb-4 mb-md-0">
            <div className="p-3 bg-white shadow-lg rounded-4 d-inline-block hover-shadow">
              <img
                src={puspak}
                alt="Dr. Puspak Samal"
                className="img-fluid rounded-4"
              />
              <div className="mt-3">
                <h5 className="mb-1 fw-bold text-dark">Dr. Puspak Samal</h5>
                <p className="text-muted mb-1">
                  Consultant Orthopaedic & Spine Surgeon
                </p>
                <span className="badge bg-primary">
                  MBBS, MS (Orthopaedics)
                </span>
              </div>
            </div>
          </div>

          <div className="col-md-8">
            <h2 className="fw-bold text-primary mb-3 position-relative">
              A Brief History
              <div
                style={{
                  height: "3px",
                  width: "80px",
                  background: "#0d6efd",
                  marginTop: "8px",
                }}
              ></div>
            </h2>

            <p className="text-muted">
              Prof. Dr. Puspak Samal is a highly acclaimed and trusted
              Orthopaedic and Spine Surgeon in Bhubaneswar, known for his
              expertise in advanced spine surgery, joint replacement, and
              complex trauma care. With over 15 years of clinical and academic
              experience, he is currently serving as Senior Consultant
              Orthopaedics & Spine Surgeon at KIMS Superspeciality Hospital,
              Bhubaneswar. Formerly, he was Senior Consultant Orthopaedics at
              IMS & SUM Hospital and Professor of Orthopaedics at IMS & SUM
              Ultimate Medicare, Bhubaneswar.
            </p>

            <p className="text-muted">
              Regarded as one of the best Orthopaedics & Spine surgeons in
              Odisha, Dr. Samal combines world-class surgical skills with
              compassionate, patient-focused care. His holistic approach,
              advanced minimally invasive techniques, and dedication to clinical
              excellence have helped thousands of patients regain mobility and
              lead pain-free lives.
            </p>

            <p className="text-muted">
              These experiences have equipped him with world-class training and
              mastery over cutting-edge surgical technologies.
            </p>

            <div className="p-3 mt-4 rounded-3 bg-light border-start border-4 border-primary">
              <h5 className="text-success fw-bold">
                Practice Focus & Philosophy
              </h5>
              <ul className="list-unstyled mt-3">
                <li className="mb-2">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  Complex trauma care, including pelvic & acetabular surgery
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  Endoscopic spine surgery (UBE & transforaminal under local
                  anaesthesia)
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  Joint replacement: Total Knee (TKR) & Total Hip (THR)
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  Arthroscopy & sports medicine procedures
                </li>
                <li>
                  <i className="bi bi-check-circle-fill text-success me-2"></i>
                  Patient-centred, minimally invasive, and evidence-based care
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
